import Vue from 'vue'

const state = {
    welcome_banner: {}
}

const actions = {
    SET_WELCOME_BANNER(context, [welcome_banner]) {
        context.commit('SAVE_WELCOME_BANNER', [welcome_banner])
    },
}

const mutations = {
    SAVE_WELCOME_BANNER: (state, [welcome_banner]) => {
        Vue.set(state, 'welcome_banner', welcome_banner)
    },
}

const getters = {
    welcome_banner: state => {
        return state.welcome_banner
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}